import React from "react";
import { Component } from "react";
import { InputField } from "../../../common/custom-form/input-filter-component";
import { SelectField } from "../../../common/custom-form/select-filter.component";
import { Button } from "react-bootstrap";
import { DropzoneComponent } from "react-dropzone-component";
import Icons from "../../../icon";
import Queued  from "../../../../../img/icon-sm-upload-blk.png";
import { DetailsDataTable } from "../../inventory/DetailsView/details-table/details-table.component";
import ButtonIcon from "../../../button";

const componentConfig = {
	postUrl: "http://localhost:3000/"
}

const eventHandlers = {

};

var ReactDOMServer = require('react-dom/server');

const djsConfig = {
	maxFilesize: 1022956339,
	maxFiles: 1,
	autoProcessQueue: false,
	parallelUploads: 50,
	uploadMultiple: false,
	dictDefaultMessage: 'Drag and drop or <b class="purple">browse</b> your files',
	dictInvalidFileType: 'Invalid file.',
	dictMaxFilesExceeded: 'Maximum number of files reached!',
	dictFileTooBig: 'File too big.',
	previewTemplate: ReactDOMServer.renderToStaticMarkup(
		<div className="dz-preview dz-file-preview">
			<div className="dz-details">
				<div>
					<Icons name="x-solid" size="12px" customClassName="dz-delete" />
				</div>
				<div className="dz-filename">
					<span data-dz-name />
				</div>
				<div className="dz-filesize">
					<span data-dz-size />
				</div>
				<div className="dz-upload-status">
					<img src={Queued} alt="file status icon" className="dz-filestatus-image" />
					<div className="dz-filestatus">Queued</div>
				</div>
			</div>
		</div>
	)

}

export class QuotationEmailValidator extends Component {
    constructor(props) {
        super(props);
        this.state={
            inputValue:"",
            filterSelected:"",
            emailTo:["markoliver@gmail.com","sampleemal@gmail.com"],
            emailCc:["markoliver@gmail.com","canson@gmail.com"],
        }
    }

    AddEmailTo=()=>{
        if(this.state.inputValue){
            this.setState({emailTo:[...this.state.emailTo,this.state.inputValue]})
        }
      
    }

    AddEmailCc=()=>{
        this.setState({emailCc:[...this.state.emailCc,this.state.inputValue]})
    }

    RemoveEmailTo=(index)=>{       
        this.setState(state=>({emailTo:[...state.emailTo.slice(0,index),...state.emailTo.slice(index +1)]}))
    }
   
    RemoveEmailCc=(index)=>{
        this.setState(state=>({emailCc:[...state.emailCc.slice(0,index),...state.emailCc.slice(index + 1)]}))
    }

    showModal() {
        this.props.showModal(false)
    }
    render() {
        return(
            <>
               
               <div className="upload-email-validator">
                    <DropzoneComponent config={componentConfig}
                            eventHandlers={eventHandlers}
                            djsConfig={djsConfig}
                    ><Icons name="cloud-upload" customClassName="email-cloud-upload" /></DropzoneComponent>
               </div>
               <div className="email-validator-file">
                   <div className="file-uploaded-container">
                        <Icons
                            name="file-lines"
                            size="18px"
                        />
                        <h3>Lorem_Ipsum-1.xls</h3>                    
                        <Icons
                            name="trash-can"
                            size="18px"
                            customClassName="icon-trash-email-upload"
                            containerClass="trash-email-upload-container"
                        />
                   </div>
                    <span className="file-size">13.2 KB</span>
               </div>
               <div className="manage-order-container email-info-container">
                    <p>Hi,</p>
                    <p>We would like to seek your assistance to process the following Other order</p>

                    <h1>Order Details</h1>
                    <DetailsDataTable classNameWrapper="max-width-container" datatable={this.props.datatable} haveEditBtn={false} haveDeleteBtn={false} />
                   
                    <p>
                       Kindly provide a quote fot this, along with confirmation on wheather the site is ON-NET and the circuit delivery lead-time.
                    </p>
                    <p>Best regards,</p>
                    <p>ATEM Telecom Support Team</p>
                    <div className="email-privacy-container">
                        <p>
                            (Privacy statement: Your personal data shall only be stored and processed in an environment where security, 
                            platform and other security policies to ensure confidentiality, integrity, and availability of personal data. 
                            Accenture will use, store and otherwise process your personal data for the purpose for which they were originally collected. 
                            Accenture will delete personal data that are no longer needed in accordance to the Global Data Privacy policy.)
                        </p>
                    </div>
               </div>
               <div className="email-button-container">
                 <ButtonIcon onClick={this.showModal.bind(this)}  customClassName="order-summary-btn" labelName="Cancel"/>  
                 <ButtonIcon onClick={()=>alert("click")}  customClassName="order-summary-btn" labelName="Send Email to Vendor"/>  
               </div>
            </>
        )
    }
}